import { useEffect, useState } from "react";
import api from "../lib/api";

/**
 * Public, no-auth endpoint — returns the current monetization toggle.
 * { visitorsPaid: bool, subscriptionsPaid: bool, updatedAt }
 * Cached in module-scope so concurrent components share one fetch.
 */
let _cached = null;
let _inflight = null;

export function fetchMonetizationState() {
  if (_cached) return Promise.resolve(_cached);
  if (_inflight) return _inflight;
  _inflight = api.get("/system/monetization")
    .then(r => { _cached = r.data; _inflight = null; return _cached; })
    .catch(() => { _inflight = null; return { visitorsPaid: false, subscriptionsPaid: false }; });
  return _inflight;
}

export function clearMonetizationCache() { _cached = null; }

export function useMonetizationState() {
  const [state, setState] = useState(_cached);
  useEffect(() => { let m = true; fetchMonetizationState().then(s => m && setState(s)); return () => { m = false; }; }, []);
  return state || { visitorsPaid: false, subscriptionsPaid: false };
}
